import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useTranslation, withTranslation } from 'react-i18next';
import { Grid, Box, MenuItem, Menu } from '@material-ui/core';
import Container from '../../components/Container'
import Typo from '../../components/CustomTypo';
import InfiniteScroll from 'react-infinite-scroll-component';
import CustomizedCircularProgress from '../../components/CircularProgress';
import ButtonCustom from '../../components/ButtonCustom';
import SubcriptionItem from './SubcriptionItem';
import { domainName, portal_config } from '../../../portal.config';
import ModalConfirm from '../../components/ModalConfirm';
import { Field, Form } from 'react-final-form';
import Modal from '../../components/Modal';
import { DatePickerComponent } from '../../components/FormElement';
import validators from '../../utils/validators';

const styles = theme => ({
    container: {
        position: 'relative',
    },
    list: {
        marginTop: theme.spacing(1)
    },
    midHeader: {
        position: 'absolute',
        top: theme.spacing(0),
        right: theme.spacing(2),
    },
    button_Filter: {
        marginRight: theme.spacing(2),
        boxShadow: 'none',
        opacity: 1,
        cursor: "pointer",
        '&:hover': {
            opacity: 0.5,
        },
    },
    item_device: {
        padding: theme.spacing(3),
        border: "1px solid " + theme.palette.border.secondary,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(3),
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(3)
    },
    devices_container: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(2, 3, 2, 3),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2, 3, 2, 3),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 2, 1, 2),
        },
    },
    marginTop2x: {
        marginTop: theme.spacing(4),
    }
});
function SubcriptionsView(props) {
    const { t } = useTranslation();
    const [showMenu, setShowMenu] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const { classes, subcriptions, showLoading, hasMore, showLoadMore, currency, periodSelected, periods, onChangeTab, serviceDevices, showModalPause, setPausePeriod, setShowModalPause } = props;
    console.log("subcription====", subcriptions);
    console.log("periods====", periods);
    console.log("periodSelected====", periodSelected);

    const StyledMenu = withStyles({
        paper: {
            border: '1px solid #d3d4d5',
            borderRadius: 12,
            top: '200px!important',
            width: 200,
        },
    })((props) => (
        <Menu
            id="subscription-menu"
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            {...props}
        />
    ));

    return (
        <Container>
            <Grid xs={12} item className={classes.container}>
                <Grid xs={12} item container alignItems='center'>
                    <Typo mg_left_xl variant='h2' light>{t('subcriptions_title')}&nbsp;</Typo>
                    <Grid item style={{ marginLeft: 20 }}>
                        <Grid item xs={12} container>
                            {periods && periods.length > 0 && periods.map((period, index) => {
                                console.log("periodSelected == period: ", periodSelected == period);
                                return (
                                    <Box key={index} style={{ paddingLeft: 8 }}>
                                        <ButtonCustom size='xs' color={periodSelected == period ? 'primary' : 'onPrimary'}
                                            fullWidth
                                            onClick={() => onChangeTab(period)}>
                                            {period.duration + " " + period.uot}
                                        </ButtonCustom>
                                    </Box>
                                );
                            })}
                        </Grid>
                    </Grid>
                    {portal_config[domainName].isShowServiceChanges && <Grid item style={{ marginLeft: 20 }}>
                        <Box>
                            <ButtonCustom size='sm' color={'onPrimary'} fullWidth onClick={(event) => setAnchorEl(event.currentTarget)}>
                                {t('btn_service_changes')}
                            </ButtonCustom>
                            <StyledMenu
                                id="custom-subscription-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                // open={showMenu}
                                open={Boolean(anchorEl)}
                                onClose={() => setAnchorEl(null)}
                            >
                                <MenuItem onClick={() => props.onUpgrade()}>
                                    <Typo>{t('upgrade_service')}</Typo>
                                </MenuItem>
                            </StyledMenu>
                        </Box>
                    </Grid>}
                </Grid>
                {showLoading && <CustomizedCircularProgress />}
                <Grid xs={12} item className={classes.list}>
                    {subcriptions && subcriptions.length > 0 &&
                        <InfiniteScroll
                            dataLength={subcriptions.length} //This is important field to render the next data
                            next={props.handleLoadMore}
                            hasMore={hasMore}
                            loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                        >
                            <Grid xs={12} item container className={classes.list}>
                                {subcriptions.map((item, idx) => (
                                    <SubcriptionItem
                                        key={idx}
                                        t={t}
                                        item={item}
                                        currency={currency}
                                        cards={props.cards}
                                        onRecurringPayment={props.onRecurringPayment}
                                        onChangeService={props.onChangeService}
                                        onConfirmActionsService={props.onConfirmActionsService}
                                    />
                                ))}
                            </Grid>
                        </InfiniteScroll>
                    }
                </Grid>
                {/* <Grid item container className={classes.midHeader} direction='row' justify='flex-end' alignItems='center'>
                    {periods && periods.length > 0 && periods.map((period, index) => {
                        console.log("periodSelected == period: ", periodSelected == period);
                        return (
                            <Box key={index}>
                                <ButtonCustom size='xs' color={periodSelected == period ? 'primary':'onPrimary'}
                                    fullWidth 
                                    onClick={() => onChangeTab(period)}>
                                     {period == 1 ? t('monthly') : period + t('month_title')}
                                </ButtonCustom>
                            </Box>
                        );
                    })}
                </Grid> */}
                {serviceDevices && serviceDevices.length > 0 && <Grid item xs={12} className={classes.list}>
                    <Typo mg_left_xl variant='h2' color='onPrimary'>{t('devices')}&nbsp;</Typo>
                    <Grid item xs={12} container className={classes.devices_container}>
                        {serviceDevices.map((service, index) => {
                            let product = service.device.product ? service.device.product : null;
                            return (
                                <Grid item xs={12} sm={6} md={6} lg={5} xl={4} key={index} className={classes.item_device}>
                                    <Grid xs={12} item className={classes.item}>
                                        <Grid item xs={12} container alignItems="center" spacing={2}>
                                            <Grid item xs={12}>
                                                <Grid item xs={12} style={{ textAlign: 'right' }}>
                                                    <ButtonCustom size="xs" color={service.state === 'DISABLED' ? 'info' : 'success'}>{service.state}</ButtonCustom>
                                                </Grid>
                                                <Typo>{t('device_id')}: <strong>{service.device && service.device.id ? service.device.id : null}</strong></Typo>
                                                <Typo>{t('product_name')}: <strong>{product && product.name ? product.name : null}</strong></Typo>
                                                <Typo>{t('serial_number')}: <strong>{service.device.serial_number ? service.device.serial_number : null}</strong></Typo>
                                            </Grid>
                                            {/* <Grid item xs={3}>
                                                <ButtonCustom size="xs" color={service.state === 'DISABLED' ? 'info' : 'success'}>{service.state}</ButtonCustom>
                                            </Grid> */}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>}
            </Grid>
            {showModalPause && showModalPause.show && <Modal
                maxWidth='xs'
                open={showModalPause.show}
                hideHeader={true}
                content={
                    <FormPauseService
                        t={t}
                        classes={classes}
                        onClose={() => {
                            setPausePeriod({
                                from_date: null,
                                to_date: null
                            });
                            setShowModalPause({});
                        }}
                        onPauseService={props.onPauseService}
                        onChangeDate={props.onChangeDate}
                    />
                }
            >
            </Modal>}
        </Container>
    );
}

function FormPauseService(props) {
    const { from_date, to_date, t, classes, onClose, onChangeDate } = props;
    return (
        <Grid item xs={12}>
            <Grid item xs={12}>
                <Typo center variant="h6">{t('pause_service')}</Typo>
            </Grid>
            <Form
                onSubmit={props.onPauseService}
                render={({ handleSubmit, reset, submitting, pristine, values }) => (
                    <Grid xs={12} container item>
                        <Field
                            name="from_date"
                            id="from_date"
                            component={DatePickerComponent}
                            label={t('from_date')}
                            isEdit={true}
                            color='default'
                            valuez={from_date}
                            onCustomChange={(e) => onChangeDate('from_date', e)}
                            validate={validators.composeValidators(validators.required)}
                        />
                        <Field
                            name="to_date"
                            component={DatePickerComponent}
                            label={t('to_date')}
                            isEdit={true}
                            color='default'
                            valuez={to_date}
                            onCustomChange={(e) => onChangeDate('to_date', e)}
                            validate={validators.composeValidators(validators.required)}
                        />
                        <Grid xs={12} item container justify='center' spacing={1} className={classes.marginTop2x}>
                            <Grid item xs={6}>
                                <ButtonCustom id="btn_pause_service_cancel" color='secondary' fullWidth onClick={() => onClose()}>{t('btn_cancel')}</ButtonCustom>
                            </Grid>
                            <Grid item xs={6}>
                                <ButtonCustom id="btn_pause_service_submit" color='primary' fullWidth onClick={handleSubmit}>{t('btn_continue')}</ButtonCustom>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            />
        </Grid>
    );
}

export default withStyles(styles)(withTranslation()(SubcriptionsView));